import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetRecipesByOrderInput } from './GetRecipesByOrderInput';
import { GetRecipesByOrderOutput } from './GetRecipesByOrderOutput';

export class GetRecipesByOrderService extends HttpServiceBase {

    handle = (input?: GetRecipesByOrderInput): Promise<Result<GetRecipesByOrderOutput>|null> => {
        const promise = this.http.get<Result<GetRecipesByOrderOutput>>(`${this.baseUrlSislogApi}/order/${input?.orderId}/recipe`);
        return promise;
    }
}